<template>
    <div class="grid__container">
        <div class="profile">
            <div class="profile__back">
                <STBackButton text="Вернуться назад" />
            </div>

            <h1 class="profile__title">
                Мой профиль
            </h1>

            <div class="profile__content">
                <template v-for="item in Object.keys(titleList)">
                    <ProfileItem
                        v-if="userData[item]"
                        :key="userData[item]"
                        :title="titleList[item]"
                        :value="userData[item]" />
                </template>

                <ProfileAgency
                    v-if="userData?.agencies?.length > 0"
                    :agencies="userData.agencies" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProfileItem from '@/blocks/Profile/ProfileItem/ProfileItem';
import ProfileAgency from '@/blocks/Profile/ProfileAgency/ProfileAgency';

export default {
    name: 'Profile',

    components: {
        ProfileAgency,
        ProfileItem
    },

    data() {
        return {
            titleList: {
                surname   : 'Фамилия',
                firstName : 'Имя',
                middleName: 'Отчество',
                phone     : 'Телефон',
                email     : 'Почта'
            }
        };
    },

    computed: {
        ...mapGetters({
            userData: 'GET_USER_DATA',
            phone   : 'GET_PHONE'
        }),
    },

    mounted() {
        this.getUserData();
    },

    methods: {
        ...mapActions(['getUserData'])
    }
};
</script>

<style lang="scss">
@import "Profile";
</style>